import { Role } from '../../../../enums/Role';
import { GetPermissionFn } from '../types';

export const getEFSEditPermission: GetPermissionFn = ({ hasRole }) => {
  if (hasRole(Role.admin, Role.efsManager)) {
    return { canView: true, canEdit: true };
  }
  return { canView: true, canEdit: false };
};
